import React from 'react';
import './App.css';

import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
  Navigate,
} from 'react-router-dom';

import { CartProvider } from './context/CartContext';
import { AuthProvider } from './context/AuthContext';
import { useAuth } from './context/AuthContext';

import Header from './components/Header';
import Footer from './components/Footer';

import HomePage from './pages/HomePage';
import ShopPage from './pages/ShopPage';
import ProductDetailPage from './pages/ProductDetailPage';
import CartPage from './pages/CartPage';
import AboutPage from './pages/AboutPage';
import AuthPage from './pages/AuthPage';
import CheckoutPage from './pages/CheckoutPage';
import OrdersPage from './pages/OrdersPage';
import ProfilePage from './pages/ProfilePage';

import AdminRoutes from './admin/routes/AdminRoutes';
import { AdminProvider } from './admin/context/AdminContext';

import { Toaster } from './components/ui/toaster';

function AppContent() {
  const location = useLocation();
  const { user, loading } = useAuth();

  // Check if current route is admin
  const isAdminRoute = location.pathname.startsWith('/admin');

  if (!loading && location.pathname === '/' && user) {
    return <Navigate to={user.role && user.role !== 'customer' ? '/admin/dashboard' : '/profile'} replace />;
  }

  return (
    <>
      {/* Hide Header on Admin Pages */}
      {!isAdminRoute && <Header />}

      <Routes>
        {/* USER WEBSITE ROUTES */}
        <Route path="/" element={<HomePage />} />
        <Route path="/shop" element={<ShopPage />} />
        <Route path="/shop/:category" element={<ShopPage />} />
        <Route path="/product/:id" element={<ProductDetailPage />} />
        <Route path="/cart" element={<CartPage />} />
        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path="/login" element={<AuthPage />} />
        <Route path="/signup" element={<AuthPage mode="signup" />} />
        <Route path="/admin/login" element={<AuthPage admin />} />
        <Route path="/admin/signup" element={<Navigate to="/admin/login" replace />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/orders" element={<OrdersPage />} />
        <Route path="/orders/:id" element={<OrdersPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/stores" element={<AboutPage />} />

        {/* ADMIN PANEL ROUTES */}
        <Route path="/admin/*" element={<AdminRoutes />} />
      </Routes>

      {/* Hide Footer on Admin Pages */}
      {!isAdminRoute && <Footer />}

      <Toaster />
    </>
  );
}

function App() {
  return (
    <div className="App bg-[#FAF7F2] min-h-screen">
      <AuthProvider>
        <AdminProvider>
          <CartProvider>
            <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
              <AppContent />
            </BrowserRouter>
          </CartProvider>
        </AdminProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
